import stCreditFixSolutionButton from './creditFixSolutionButton.component';

export default angular
  .module('st.Integrations.CreditFixSolution', ['st.Core', 'angular-cache'])
  .component('stCreditFixSolutionButton', stCreditFixSolutionButton)
  .service('creditFixSolutionService', ($http, dataService, CREDIT_FIX_SOLUTION) => ({
    refer: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CREDIT_FIX_SOLUTION.API.REFER,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('CREDIT_FIX_SOLUTION', {
    API: {
      REFER: '/api/v1/integrations/credit-fix-solution/refer/'
    }
  });
